import React from "react";

import { useUi } from "@jelly/lesson";
import { Modal } from "@jelly/ui";
import { useIntl } from "react-intl";

import { messages } from "../Case1TechnicalPov.messages";
import { nl2p } from "@src/utils/nl2p";

type SignalFlowModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;

export const SignalFlowModal: React.FC<SignalFlowModalProps> = (props) => {
  const ui = useUi();
  const { formatMessage } = useIntl();

  return (
    <ui.Modal {...props} title={formatMessage(messages.modalSignalFlowTitle)}>
      <div style={{ width: "90vw", maxWidth: "1000px" }}>
        <ui.Scrollbars autoHeight autoHeightMax={"70vh"}>
          {nl2p(formatMessage(messages.modalSignalFlowDescription))}
        </ui.Scrollbars>
      </div>
    </ui.Modal>
  );
};
